import { createConfig, injected } from '@wagmi/core';
import { polygon } from '@wagmi/core/chains';
import { createPolygonTransport } from './polygonRpc';

// Public reads always stay on Polygon, even when the connected wallet changes chain.
export const config = createConfig({
  chains: [polygon],
  connectors: [injected({ target: { id: 'native-wallet', name: '錢包', provider: window => window?.ethereum }, shimDisconnect: true, unstable_shimAsyncInject: 2000 })],
  transports: { [polygon.id]: createPolygonTransport() },
  syncConnectedChain: false,
  multiInjectedProviderDiscovery: true,
});
